module.exports = __webpack_public_path__ + "img/logo_home@3x.214bf8b1.png";